/* eslint-disable */
import React, { useState, useEffect } from "react";
import { GET_PERCENTAGE, GET_TOKEN, CURRENCY } from "../../../helpers";
import { API_URL, GET_SALES_REPORT_DONUT } from "../../../constants";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { EmptyData } from "../../Global/EmptyData/EmptyData";
import "./WidgetGraphDonutSalesByCountry.css";

export const WidgetGraphDonutSalesByCountry = (props) => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [salesByCountry, setSalesByCountry] = useState([]);
  const RADIAN = Math.PI / 180;

  useEffect(() => {
    setDataLoaded(false);
    let hasDates = props?.filterPayload?.from || props?.filterPayload?.to;
    
    const generateString = () => {
      let resultString = "/?";
      
      const querryString = {
        from:
            (props.filterPayload && props.filterPayload.from) &&
            props.filterPayload.from.getFullYear() +
            "-" +
            ( props.filterPayload.from.getMonth() + 1) +
            "-" +
            props.filterPayload.from.getDate(),
        to:
            (props.filterPayload && props.filterPayload.to) &&
            props.filterPayload.to.getFullYear() +
            "-" +
            ( props.filterPayload.to.getMonth() + 1) +
            "-" +
            props.filterPayload.to.getDate(),
      };

      //eslint-disable-next-line
      Object.entries(querryString).map(([fieldItem, fieldItemValue]) => {
        if (fieldItemValue !== undefined && fieldItemValue !== null) {
          return (resultString = resultString.concat(`${fieldItem}=${fieldItemValue}&`));
        }
      });

      return resultString;
    };
    

    fetch(
      API_URL +
        GET_SALES_REPORT_DONUT +
        generateString() +
        `region=${props.countryFilter || 'all'}&` +
        ((props.globalDays && !hasDates) ? `days=${props.globalDays}&` : '') + 
        `&currency=${props.globalCurrency}`,
      {
        method: "get",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(),
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        response.currency_symbol && setCurrency(response.currency_symbol);

        setSalesByCountry(response);
      })
      .then(() => setDataLoaded(true));
  }, [props.globalDays, props.globalCurrency, props.countryFilter, props.filterPayload]);

  let sumOfCoutriesPrices = 0;

  const COLORS = ["#673490", "#9C5DCE", "#C856FA", "#B179E0", "#C79CED"];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active) {
      return (
        <div className="WidgetGraphDonutSalesByCountry__tooltip border-dark">
          <div className="top-row">
            <div className="name flex-align-center">
              {payload[0].payload.img && (
                <img
                  src={payload[0].payload.img}
                  className="flag-icon-img"
                  alt={payload[0].name}
                />
              )}

              {payload[0].name}
            </div>

            <div className="percentage">
              {GET_PERCENTAGE(payload[0].value, sumOfCoutriesPrices).toFixed(
                0
              ) + "%"}

              <span
                className="identity"
                style={{ backgroundColor: payload[0].payload.fill }}
              ></span>
            </div>
          </div>

          <div className="main-price">
            {CURRENCY(payload[0].value, payload[0].payload.currency_symbol)}
          </div>

          <div
            className={
              "difference " +
              (payload[0].payload.differenceType ? "positive " : "negative ")
            }
          >
            {CURRENCY(
              payload[0].payload.difference,
              payload[0].currency_symbol
            ) + ` (${payload[0].payload.differencePercent}%)`}
          </div>
        </div>
      );
    }

    return null;
  };

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (

      (percent * 100).toFixed(0) > 10 ? (
        <text
          x={x}
          y={y}
          className="rechart-percent"
          fill="white"
          textAnchor="middle"
          dominantBaseline="central"
        >
          {`${(percent * 100).toFixed(0)}%`}
        </text>
      ) : (
        <text
          x={x}
          y={y}
          className="rechart-percent"
          fill="white"
          textAnchor="middle"
          dominantBaseline="central"
        >
        </text>
      )
    );
  };

  const listOfCountires = () => {
    return salesByCountry.map((item, index) => {
      const changeColor = index % 5 === 0 && index !== 0;

      sumOfCoutriesPrices += item.price;

      return (
        <Cell key={`cell-${index}`} fill={COLORS[ changeColor ? 2 : index % COLORS.length ]} />
      );
    });
  };

  // https://www.freakyjolly.com/react-charts-examples/#.X1ZlAGczbUJ

  return (
    <>
      <div className="Salesreport__donut-sales-by-country widget half-width-dashboard">
        <h2> Donut Sales by country </h2>
        <div className="border">
          {salesByCountry.length > 0 && dataLoaded === true ? (
            <ResponsiveContainer width="100%" height={400}>
              <PieChart>
                <Pie
                  data={salesByCountry}
                  color="#000000"
                  dataKey="price"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  blendStroke
                  labelLine={false}
                  label={renderCustomizedLabel}
                  outerRadius={120}
                  innerRadius={80}
                  fill="#8884d8"
                >
                  {listOfCountires()}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
                <Legend
                  layout="vertical"
                  verticalAlign="middle"
                  align="right"
                  wrapperStyle={{
                    paddingLeft: "10px",
                  }}
                />
              </PieChart>
            </ResponsiveContainer>
          ) : dataLoaded ? (
            <EmptyData title="No sales data in selected period found" />
          ) : (
            <div className="loading">
              <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
